import React from 'react'
import { DialogProps } from '../../types/Utils';
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useFieldArray, useForm, Controller, } from 'react-hook-form';
import {
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  IconButton,
  Button,
} from "@mui/material";
import FancyDialogActions from './FancyDialogActions';
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";

interface AddOrUpdateNotification {
    id?: number;
    name: string;
    emails?: any[];
    active: boolean;
}

const AddOrUpdateNotificationModal = ({ actionButton, data, onSubmit, cancelModal, modalType, roleData }: DialogProps) => {
  const validation = Yup.object().shape({
    name: Yup.string().required("Campo es requerido"),
    emails: Yup.array()
      .of(
        Yup.string().required("Campo es requerido").email("Debe ser un correo válido")
      )
      .min(1, "Debe agregar al menos un correo"),
    active: Yup.boolean().required("Campo es requerido"),
  });

    const defaultValues = {
        id: data?.id,
        name: data?.event ?? "",
        emails: data?.emails ?? [],
        active: data?.active ?? true,
    };

    const {
        handleSubmit,
        formState: { errors },
        control,
    } = useForm<AddOrUpdateNotification>({
        defaultValues,
        resolver: yupResolver(validation),
        mode: "onChange",
    });

    const { fields, append, remove } = useFieldArray({
        control,
        name: "emails",
    });


    return (
      <>
      <DialogTitle id="alert-dialog-title" sx={{ pt: 4, px: 4 }}>
        {modalType === "create" ? "Crear Notificación" : "Actualizar Notificación"}
      </DialogTitle>
      <DialogContent sx={{ px: 4, pb: 0 }}>
        <form>
          <Grid container spacing={3} maxWidth="lg" sx={{ pt: 4, pb: 8 }}>
            <Grid item xs={12}>
              <Controller
                name="name"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    disabled={modalType === "update"}
                    size="small"
                    label="Nombre"
                    type="text"
                    variant="outlined"
                    error={Boolean(errors.name)}
                    helperText={errors.name?.message}
                    InputLabelProps={{ shrink: true }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                {fields.map((item, index) => (
                  <Grid
                    key={item.id}
                    item
                    xs={12}
                    display="flex"
                    alignItems="center"
                  >
                    <Controller
                      name={`emails.${index}`}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          fullWidth
                          size="small"
                          label={`Correo ${index + 1}`}
                          type="email"
                          variant="outlined"
                          error={Boolean(errors.emails?.[index])}
                          helperText={
                            errors.emails?.[index]
                              ? String(errors.emails[index]?.message)
                              : undefined
                          }
                          InputLabelProps={{ shrink: true }}
                        />
                      )}
                    />
                    <IconButton
                      onClick={() => remove(index)}
                      color="error"
                      size="small"
                      sx={{ ml: 2 }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Grid>
                ))}
                <Grid item xs={12} sx={{ mb: 2 }}>
                  <Button
                    variant="outlined"
                    startIcon={<AddIcon />}
                    onClick={() => append("")}
                    sx={{ mb: 2 }}
                  >
                    Agregar Correo
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="active"
                    control={control}
                    defaultValue={true}
                    render={({ field }) => (
                      <Grid container alignItems="center">
                        <span style={{ marginRight: 16 }}>Estado:</span>
                          <label style={{ marginRight: 16 }}>
                            <input
                              type="radio"
                              value="true"
                              checked={field.value === true}
                              onChange={() => field.onChange(true)}
                            /> Activo
                          </label>
                          <label>
                            <input
                              type="radio"
                              value="false"
                              checked={field.value === false}
                              onChange={() => field.onChange(false)}
                            /> Desactivado
                          </label>
                      </Grid>
                    )}
                  />
                </Grid>
                {errors.emails && typeof errors.emails.message === 'string' && (
                  <Grid item xs={12}>
                    <span style={{ color: '#d32f2f', fontSize: 13 }}>
                      {errors.emails.message}
                    </span>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
      <FancyDialogActions
        handleAccept={handleSubmit(onSubmit)}
        cancelModal={cancelModal}
      />
    </>
    )
}

export default AddOrUpdateNotificationModal